import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const NAMES = ['María G. de Ciudad de México', 'Carlos R. de Bogotá', 'Ana P. de Madrid', 'Laura M. de Buenos Aires', 'Sofía L. de Santiago', 'Diego F. de Lima', 'Valentina S. de Montevideo', 'Lucía T. de Barcelona'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [name, setName] = useState('');
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      setName(randomName);
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      // Schedule next notification (random time between 15-45 seconds)
      const nextTime = Math.random() * (45000 - 15000) + 15000;
      setTimeout(showNotification, nextTime);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-50">
      <div className="bg-white rounded-lg shadow-xl border border-green-100 p-4 max-w-sm flex items-start gap-3 pr-8 relative" data-id="element-51">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-52">
          <X size={14} data-id="element-53" />
        </button>

        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-54">
          <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-55" />
        </div>

        <div data-id="element-56">
          <p className="text-sm font-semibold text-gray-900" data-id="element-57">{name}</p>
          <p className="text-xs text-gray-600" data-id="element-58">
            acaba de comprar el{' '}
            <span className="font-bold text-green-700" data-id="element-59">MegaPack Biología</span>
          </p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-60">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}